import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Andika, Fredoka } from 'next/font/google'

const sans = Fredoka({
    subsets: ['latin']
})

const reading = Andika({
    subsets: ['latin'],
    weight: ['400', '700']
})

const monoStack = 'ui-monospace, SFMono-Regular, Menlo, monospace'

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${monoStack};--font-app-heading:${sans.style.fontFamily};--font-app-reading:${reading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
